import { render } from "./YoutubeCreate.vue?vue&type=template&id=50ca6687"
import script from "./YoutubeCreate.vue?vue&type=script&lang=js"
export * from "./YoutubeCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__